import { SearchParamSaver } from './searchParamSaver';

/**
 * Manager of all SearchParamSaver instances.
 */
export class SearchParamSaversManager {
  /**
   * Creates a new instance of SearchParamSaversManager.
   * 
   * @constructor
   * @param {Object} options - List of configurations options for the saver instances.
   */
  constructor(saversOptions = []) {
    this._saversOptions = saversOptions;;
    this._savers = {};
  }

  /**
   * Initializes all SearchParamSaver instances.
   * 
   * Call this method after page loading.
   * 
   * @returns {void}
   */
  init() {
    this._saversOptions.forEach((options) => {
      this._savers[options.name] = new SearchParamSaver(options);
      this._savers[options.name].init();
    });
  }

  /**
   * Get SearchParamSaver instance by name.
   * 
   * @returns {SearchParamSaver|null}
   */
  get(name) {
    return this._savers[name] || null;
  }
}
